import { AsyncAction } from '../types'
import { ConfigurationTransferToExpertModeAction } from '../types/configurationTypes'
import { ConfiguratorMode, UISelectApplicationAction, UiSetModeAction } from '../types/uiTypes'

export const applicationSelectAction = (
  id?: string,
  movementDirection?: 'next' | 'previous'
): AsyncAction<UISelectApplicationAction> => (dispatch, getState) => {
  if (getState().data.applications.find((x) => x.id === id)) {
    dispatch({
      type: 'UI/Inspiration/SelectApplication',
      id,
      movementDirection
    })
  }
}

export const applicationNextAction = (): AsyncAction<UISelectApplicationAction> => (dispatch, getState) => {
  const currentApplication = getState().ui.inspiration.application
  const applications = getState().data.applications
  let nextIndex = applications.findIndex(({ id }) => id === currentApplication) + 1
  if (nextIndex >= applications.length) {
    nextIndex = 0
  }
  dispatch({
    type: 'UI/Inspiration/SelectApplication',
    id: applications[nextIndex].id,
    movementDirection: 'next'
  })
}

export const applicationPreviousAction = (): AsyncAction<UISelectApplicationAction> => (dispatch, getState) => {
  const currentApplication = getState().ui.inspiration.application
  const applications = getState().data.applications
  let nextIndex = applications.findIndex(({ id }) => id === currentApplication) - 1
  if (nextIndex < 0) {
    nextIndex = applications.length - 1
  }
  dispatch({
    type: 'UI/Inspiration/SelectApplication',
    id: applications[nextIndex].id,
    movementDirection: 'previous'
  })
}

export const expertLoadInspirationConfigurationAction = (
  applicationId: string,
  closeOverlay?: boolean
): AsyncAction => (dispatch, getState) => {
  const data = getState().data
  if (data.applications.find((x) => x.id === applicationId)) {
    dispatch({
      type: 'Configuration/TransferToExpertMode',
      applicationId: applicationId,
      data: getState().data
    })
  }
  if (closeOverlay) {
    dispatch({
      type: 'UI/Expert/ShowApplicationOverlay',
      show: false
    })
  }
}

export const setModeAction = (
  mode: ConfiguratorMode
): AsyncAction<UiSetModeAction | ConfigurationTransferToExpertModeAction> => (dispatch, getState) => {
  const url = getState().data.urls?.[mode === 'expert' ? 'expertMode' : 'inspirationMode'] + location.hash
  history.replaceState(null, document.title, url)

  if (mode === 'expert') {
    dispatch({
      type: 'Configuration/TransferToExpertMode',
      applicationId: getState().ui.inspiration.application,
      data: getState().data
    })
  }

  dispatch({
    type: 'Ui/SetMode',
    mode
  })
}
